import './item.css';

import * as React from 'react';
import Utility from 'src/common/Utility';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';
import Note from 'src/entities/Note';

import CheckGreen from '../../res/img/check_green.svg';
import Profile from '../../res/img/member.svg';
import PlusRed from '../../res/img/plus_red.svg';
import TrashbinGreenLight from '../../res/img/trashbin_green_light.svg';

interface IProps {
  note: Note;
  group: Group;
  account: Member;
  members: Member[];
  updateNote: (note: Note) => void;
  destroyNote: (note: Note) => void;
}

interface IState {
  isEditingText: boolean;
  isUnCheckersShown: boolean;
  note: Note;
  isWatcher: boolean;
}

class ItemComponent extends React.Component<IProps, IState> {
  editText: HTMLTextAreaElement;

  constructor(props: any) {
    super(props);
    this.state = {
      isEditingText: false,
      isUnCheckersShown: false,
      note: this.props.note,
      isWatcher: this.props.group.watchers.includes(this.props.account.id)
    };

    this.onEditingText = this.onEditingText.bind(this);
    this.offEditingText = this.offEditingText.bind(this);
    this.check = this.check.bind(this);
    this.onChangeText = this.onChangeText.bind(this);
    this.displayUnCheckers = this.displayUnCheckers.bind(this);
  }

  render() {
    const creator = this.props.members.find(
      member => member.id === this.state.note.memberId
    );

    return (
      <div className="NoteItem">
        <div className="Header">
          <div className="Title">{this.props.note.title}</div>
          <div className="Right">
            <div className="Created">
              {'`' +
                Utility.dateFormat(
                  new Date(this.props.note.created),
                  'yy年M月d日'
                )}
            </div>
            <div
              className="Destroy"
              onMouseUp={this.destroyNote.bind(this, this.props.note)}
              onTouchEnd={this.destroyNote.bind(this, this.props.note)}
            >
              <img src={TrashbinGreenLight} />
            </div>
          </div>
        </div>
        <div className="Content">
          <div className="ContentHeader">
            <div className="Members">
              <div className="Checkers">
                <div className="CheckTitle">
                  <img src={CheckGreen} />
                </div>
                {this.props.note.checkers.map(checker =>
                  this.renderChecker(checker)
                )}

                {!this.props.note.checkers.includes(this.props.account.id) &&
                !this.state.isWatcher ? (
                  <div className="Check">
                    <div
                      className="Add"
                      onMouseUp={this.check}
                      onTouchEnd={this.check}
                    >
                      <img src={PlusRed} />
                    </div>
                    <span>{this.props.account.nameLast}</span>
                  </div>
                ) : null}

                {!this.state.isUnCheckersShown ? (
                  <span
                    className="DisplayUnCheckers"
                    onClick={this.displayUnCheckers}
                  >
                    未チェックのメンバー
                  </span>
                ) : null}
              </div>
              {this.state.isUnCheckersShown ? (
                <div className="UnCheckers">
                  <div className="UnCheckTitle">
                    未チェックの
                    <br />
                    メンバー
                  </div>
                  {this.props.members
                    .filter(
                      member => !this.props.note.checkers.includes(member.id)
                    )
                    .map(checker => this.renderChecker(checker.id))}
                </div>
              ) : null}
            </div>

            {creator !== undefined ? (
              <div className="Creator">
                {creator !== undefined ? (
                  <img
                    src={creator.profile !== null ? creator.profile : Profile}
                  />
                ) : null}
                <span>{creator.nameLast + creator.nameFirst}</span>
              </div>
            ) : null}
          </div>
          {!this.state.isEditingText ? (
            <div className="Text" onDoubleClick={this.onEditingText}>
              {Utility.nl2br(this.state.note.text)}
            </div>
          ) : (
            <textarea
              ref={text => {
                this.editText = text as HTMLTextAreaElement;
              }}
              value={this.state.note.text}
              onChange={this.onChangeText}
              onBlur={this.offEditingText}
            />
          )}
        </div>
      </div>
    );
  }

  renderChecker(memberId: number) {
    const checker = this.props.members.find(member => member.id === memberId);
    if (checker !== undefined) {
      return (
        <div className="Checker" key={memberId}>
          <img src={checker.profile !== null ? checker.profile : Profile} />
          <span>{checker.nameLast}</span>
        </div>
      );
    } else {
      return null;
    }
  }

  destroyNote(note: Note) {
    if (confirm('削除します')) {
      this.props.destroyNote(note);
    }
  }

  displayUnCheckers() {
    this.setState({
      isUnCheckersShown: true
    });
  }

  check(e: any) {
    const note = Object.assign({}, this.props.note);
    note.checkers.push(this.props.account.id);

    this.props.updateNote(note);
  }

  onChangeText(e: any) {
    const note = Object.assign({}, this.state.note);
    note.text = e.target.value;
    this.setState({
      note
    });
  }

  onEditingText(e: any) {
    if (this.props.group.admins.includes(this.props.account.id)) {
      this.setState({
        isEditingText: true
      });
      setTimeout(() => {
        this.editText.focus();
      }, 10);
    }
  }

  offEditingText(e: any) {
    this.setState({
      isEditingText: false
    });
    this.props.updateNote(this.state.note);
  }
}

export default ItemComponent;



// WEBPACK FOOTER //
// ./src/components/Note/item.tsx